import { Box, Grid, LinearProgress, Theme, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import ViewProfileOverview from "./ViewProfileOverview";
import RMDetails from "./RMDetails";
import PersonalDetails from "./PersonalDetails";
import RelatedPersonDetails from "./RelatedPersonDetails";
import ContactDetails from "./ContactDetails";
import NonIndividualContactDetails from "../../NonIndividualApplicationDetails/ContactDetails"
import AdditionalKYCDetails from "./AdditionalKYCDetails";
import NomineeDetails from "./NomineeDetails";
import FatcaDetails from "./FatcaDetails";
import BankDetails from "./BankDetails";
import NonIndividualBankDetails from "../../ApplicationDetails/BankDetails";
import RiskProfileDetails from "./RiskProfileDetails";
import InvestmentPreferenceDetails from "./InvestmentPreferenceDetails";
import ServicePreferenceDetails from "./ServicePreferenceDetails";
import { useHistory } from "react-router";
import { getApplicationDetailsByClientCode } from "../../../redux-store/actions/investorProfile";
import DocumentDetails from "./DocumentDetails";
import { RootStateType } from "../../../redux-store/reducers";
import BreadCrum from "../../../lib/BreadCrum";
import { isRMLikeRole, maskInfo } from "../../../utils/utilityFunctions";
import NexEdgeInvPrefDetails from "./NexEdgeInvPrefDetails";
import Consent from "./Consent";
import { APPLICATION_TYPE, PHYSICAL_DIGITAL_FLOW } from "../../../utils/constant";
import DistributorDetails from "../../ApplicationDetails/rmDetails";
import ContributorDetails from "../../NonIndividualApplicationDetails/ContributorDetails";
import AuthorizedSignatories from "../../NonIndividualApplicationDetails/AuthorisedSignatories";
import Fatca from "../../NonIndividualApplicationDetails/fatca";
import RiskProfile from "../../NonIndividualApplicationDetails/RiskProfile";
import InvPref from "../../NonIndividualApplicationDetails/InvPref";
import Documents from "../../NonIndividualApplicationDetails/Document";
import Ubo from "../../NonIndividualApplicationDetails/ubo";
import SupportDetails from "./SupportDetails";

function IndividualProfileSections({
    viewProfileData = {}
}: {
    viewProfileData: any
}): JSX.Element {
    return (
        <>
            {PHYSICAL_DIGITAL_FLOW && (
                <Box id="Consent">
                    <Consent overviewData={viewProfileData ?? {}} />
                </Box>
            )}
            <Box id="Overview">
                <ViewProfileOverview overviewData={viewProfileData ?? {}} />
            </Box>
            {/* <Box id="RM Details">
                <RMDetails overviewData={viewProfileData ?? {}} />
            </Box> */}
            <Box id="Support Details">
                <SupportDetails />
                {/* <RMDetails overviewData={viewProfileData ?? {}} /> */}
            </Box>
            <Box id='Personal Details'>
                <PersonalDetails overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id="Details of Related Person">
                <RelatedPersonDetails overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id='Contact Details'>
                <ContactDetails overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id='Additional KYC'>
                <AdditionalKYCDetails overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id='Nominee Details'>
                <NomineeDetails overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id='FATCA Declaration'>
                <FatcaDetails overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id="Bank Details">
                <BankDetails overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id='Risk Profile'>
                <RiskProfileDetails overviewData={viewProfileData ?? {}} />
            </Box>
            {/* Commented for NexEdge client */}
            {/* <div id='Investment Preference'>
                                    <InvestmentPreferenceDetails overviewData={viewProfileData ?? {}} />
                                </div> */}
            {/* <Box id='Investment Preference'>
                <NexEdgeInvPrefDetails overviewData={viewProfileData ?? {}} />
            </Box> */}
            {/* <div id='Service Preference'>
                                    <ServicePreferenceDetails overviewData={viewProfileData ?? {}} />
                                </div> */}
            <Box id='Upload Documents'>
                <DocumentDetails overviewData={viewProfileData ?? {}} />
            </Box>
        </>
    )
}

function NonIndividualProfileSections({
    viewProfileData = {}
}: {
    viewProfileData: any
}): JSX.Element {
    return (
        <>
            {PHYSICAL_DIGITAL_FLOW && (
                <Box id="Consent">
                    <Consent overviewData={viewProfileData ?? {}} />
                </Box>
            )}
            <Box id="Distributor Details">
                <DistributorDetails application={viewProfileData ?? {}} hideBseESignStatus />
            </Box>
            <Box id='Contributor Details'>
                <ContributorDetails applicants={viewProfileData?.applicants ?? []} />
            </Box>
            <Box id="Contact Details">
                <NonIndividualContactDetails applicants={viewProfileData?.applicants ?? []} />
            </Box>
            <Box id='Investor’s Bank Details'>
                <NonIndividualBankDetails banks={viewProfileData?.banks ?? []} />
            </Box>
            <Box id='Authorised Signatory'>
                <AuthorizedSignatories groups={viewProfileData?.groups ?? []} />
            </Box>
            <Box id='Declaration of UBO'>
                <Ubo application={viewProfileData ?? {}} />
            </Box>
            <Box id='FATCA'>
                <Fatca applicants={viewProfileData?.applicants ?? []} />
            </Box>
            {/* <Box id="Risk Profile">
                <RiskProfile application={viewProfileData ?? {}} />
            </Box> */}
            {/* <Box id='Investment Preference'>
                <InvPref application={viewProfileData ?? {}} />
            </Box> */}
            <Box id='Document Details'>
                <Documents application={viewProfileData ?? {}} />
            </Box>
        </>
    )
}

export default function ViewProfile(): JSX.Element {
    const history = useHistory();
    const { state, pathname: pathName } = history.location;
    const [onboardingType, setOnboardingType] = useState<string>('');
    const [applicationType, setApplicationType] = useState<string>('')
    const [loading, setLoading] = useState(false);
    const [viewProfileData, setViewProfileData] = useState();
    const dispatch = useDispatch();
    const { familyMemberId = "" } = useSelector((store: RootStateType) => store.id);

    const {
        role = '',
    } = useSelector((store: RootStateType) => store.auth);
    const {
        selectedPortfolio
    } = useSelector((store: RootStateType) => store.selectedPortfiolio);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const clientCode = ((state as any)?.clientCode ?? '') as string;

    const fetchViewProfileData = async () => {
        setLoading(true);

        const ans = (await dispatch(getApplicationDetailsByClientCode({
            clientCode: clientCode
        }))) as any;

        const modifiedResponse = {
            ...ans ?? {},
            name: maskInfo(ans?.name ?? ""),
            pan: maskInfo(ans?.pan ?? ""),
            mobile: maskInfo(ans?.mobile ?? ""),
            email: maskInfo(ans?.email ?? ""),
            rm: {
                ...ans?.rm ?? {},
                user: {
                    ...ans?.rm?.user ?? {},
                    email: maskInfo(ans?.rm?.user?.email ?? ""),
                    phone: maskInfo(ans?.rm?.user?.phone ?? ""),
                    firstName: maskInfo(ans?.rm?.user?.firstName ?? ""),
                }
            },
            applicants: (ans?.applicants ?? [])?.map((ele: any) => ({
                ...ele,
                firstName: maskInfo(ele?.firstName ?? ""),
                lastName: maskInfo(ele?.lastName ?? ""),
                panNo: maskInfo(ele?.panNo ?? ""),
                email: maskInfo(ele?.email ?? ""),
                mobile: maskInfo(ele?.mobile ?? ""),
                kraMobileNumber: maskInfo(ele?.kraMobileNumber ?? ""),
            })) ?? [],
            banks: (ans?.banks ?? []).map((ele: any) => ({
                ...ele,
                bankAccountNumber: maskInfo(ele?.bankAccountNumber ?? ""),
                ifscCode: maskInfo(ele?.ifscCode ?? ""),
                micrCode: maskInfo(ele?.micrCode ?? ""),
            })) ?? [],
        }
        setOnboardingType(modifiedResponse?.onboardingType ?? "");
        setApplicationType(modifiedResponse?.applicationType ?? "");
        setViewProfileData(modifiedResponse);
        setLoading(false);

    }
    useEffect(() => {
        fetchViewProfileData();

    }, [])

    const initialRouter = pathName.split('/').filter((item) => item !== '')
    const rmRouterPath = [
        {
            name: 'Dashboard',
            path: '/dashboard',
            // warning: true
        },
        {
            name: `${initialRouter[1]}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode: clientCode || ""
            }
        },
        {
            name: 'View Profile',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
            state: {
                clientCode: clientCode || ""
            }
        }
    ]

    const investorRouterPath = [
        ...(familyMemberId
            ?
            [{
                name: 'View Family',
                path: `/investor-family/family-profile/${familyMemberId}`,
            }, {
                name: `${initialRouter[1]}`,
                path: `/${initialRouter[0]}/${initialRouter[1]}`,
            }]
            :
            [{

                name: `Dashboard`,
                path: '/investor-dashboard',
                // warning: true
            }]),
        {
            name: 'View Profile',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
            state: {
                clientCode: clientCode || ""
            }
        }
    ]


    // const viewProfileHeaders = PHYSICAL_DIGITAL_FLOW ? [
    // 'Consent',
    //     'Overview',
    //     'RM Details',
    //     "Personal Details",
    //     "Details of Related Person",
    //     "Contact Details",
    //     "Additional KYC",
    //     "Nominee Details",
    //     "FATCA Declaration",
    //     "Bank Details",
    //     "Risk Profile",
    //     // "Investment Preference",
    //     // "Service Preference",
    //     "Upload Documents",
    // ] : [
    //     'Overview',
    //     'RM Details',
    //     "Personal Details",
    //     "Details of Related Person",
    //     "Contact Details",
    //     "Additional KYC",
    //     "Nominee Details",
    //     "FATCA Declaration",
    //     "Bank Details",
    //     "Risk Profile",
    //     // "Investment Preference",
    //     // "Service Preference",
    //     "Upload Documents",
    // ]

    const individualProfileHeaders = [
        'Overview',
        // 'RM Details',
        'Support Details',
        "Personal Details",
        "Details of Related Person",
        "Contact Details",
        "Additional KYC",
        "Nominee Details",
        "FATCA Declaration",
        "Bank Details",
        "Risk Profile",
        // "Investment Preference",
        // "Service Preference",
        "Upload Documents",
    ]

    const nonIndividualProfileHeaders = [
        "Distributor Details",
        "Contributor Details",
        "Contact Details",
        "Investor’s Bank Details",
        "Authorised Signatory",
        "Declaration of UBO",
        "FATCA",
        // "Risk Profile",
        // "Investment Preference",
        "Document Details"
    ]

    const viewProfileHeaders = [
        ...(PHYSICAL_DIGITAL_FLOW ? ['Consent'] : []),
        ...(
            `${applicationType ?? ""}`.toLowerCase() === APPLICATION_TYPE.INDIVIDUAL ? individualProfileHeaders : nonIndividualProfileHeaders
        )
    ]

    const scrollToContent = (id: string) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const [activeHeader, setActiveHeader] = useState(viewProfileHeaders[0]);

    return (
        <>
            {loading ? <LinearProgress /> : <Box>

                <Box sx={{ width: '100%' }}>
                    <BreadCrum array={isRMLikeRole(role) ? rmRouterPath : investorRouterPath} />
                </Box>
                {/* Main Data */}
                <Box sx={(theme: Theme) => ({
                    p: { xs: "19px 8px 35px 9px", sm: "35px 35px 35px 25px" },
                    border: `1px solid ${theme.palette.text.secondary}26`,
                    borderRadius: "15px",
                    background: theme.palette.background.paper,
                    mt: '20px'
                })}>
                    <Grid container columnSpacing={'15px'} >
                        <Grid
                            item
                            xs={12}
                            md={4}
                            lg={3}
                            sx={{
                                padding: 0,
                                position: 'sticky',
                                top: '0',
                                // height: 'calc(100vh + 60px)',
                                height: 'fit-content',
                                display: { xs: "none", md: "block" },
                            }}
                        >
                            <Box sx={{ mt: '25px' }} role="navigation" aria-label="Profile sections">
                                {viewProfileHeaders.map((header: string, index: number) => (
                                    <Box
                                        key={index}
                                        role="button"
                                        tabIndex={0}
                                        aria-current={activeHeader === header ? 'true' : undefined}
                                        onClick={() => {
                                            setActiveHeader(header);
                                            scrollToContent(header);
                                        }}
                                        onKeyDown={(e: React.KeyboardEvent) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                setActiveHeader(header);
                                                scrollToContent(header);
                                            }
                                        }}
                                        sx={(theme: Theme) => (
                                            {
                                                mt: index !== 0 ? '15px' : 0,
                                                backgroundColor: activeHeader === header ? theme.palette.primary[500] : theme.palette.common.white,
                                                borderRadius: '8px',
                                                padding: '10px 20px',
                                                cursor: 'pointer',
                                            })}

                                    >
                                        <Typography component={'span'} variant="body_500" sx={(theme: Theme) => ({
                                            color: activeHeader === header ? 'textDark.primary' : 'text.secondary',
                                        })}>{header}</Typography>
                                    </Box>
                                ))}
                            </Box>
                        </Grid>
                        <Grid item
                            container
                            xs={12}
                            md={8}
                            lg={9}
                        >
                            <Box component={'div'} sx={(theme: Theme) => ({ padding: { xs: '9px', sm: '35px' }, border: `1px solid ${theme.palette.text.secondary}26`, borderRadius: '15px', backgroundColor: `${theme.palette.common.white}`, width: '100%' })}>
                                {
                                    (`${applicationType ?? ""}`.toLowerCase() === APPLICATION_TYPE.INDIVIDUAL) ? (
                                        <IndividualProfileSections
                                            viewProfileData={viewProfileData} />
                                    ) : (
                                        <NonIndividualProfileSections
                                            viewProfileData={viewProfileData} />
                                    )
                                }

                            </Box>

                        </Grid>
                    </Grid>

                </Box>
            </Box>}
        </>
    )
}
